<div class="tooltip-container {{ classContainer }}">
  <ng-template #tooltip>
    <div class="content">
      <div [innerHTML]="content"></div>

      <ng-template #dynamicContainer></ng-template>

      @if (template) {
        <ng-container *ngTemplateOutlet="template"> </ng-container>
      }
    </div>
  </ng-template>

  <ng-container *limitUp="DEVICE_SIZE.DESKTOP">
    <span class="icon material-symbols-outlined" [pTooltip]="tooltip" [tooltipStyleClass]="tooltipStyleClass"> {{ icon }} </span>
  </ng-container>

  <button
    #tooltipButton
    type="button"
    class="btn-tooltip"
    [pTooltip]="tooltip"
    [tooltipStyleClass]="tooltipStyleClass"
    tooltipEvent="focus"
    (click)="focusTooltipButton()"
    *smallerThan="DEVICE_SIZE.DESKTOP"
  >
    <span class="icon material-symbols-outlined"> {{ icon }} </span>
  </button>
</div>
